import classNames from 'classnames';
import React, { cloneElement, Component, PropsWithChildren, ReactElement } from 'react';
import './NavStyle.scss';
import { INavItemProps, INavProps } from './types';

export class Nav extends Component<PropsWithChildren<INavProps>, {}> {
  public static defaultProps = {
    bsStyle: 'tabs',
  };

  // returns true when Navitem is active
  public isActive(navItem: ReactElement<INavItemProps>) {
    const { activeKey } = this.props;
    if (activeKey && navItem.props.eventKey === activeKey) {
      return true;
    } else {
      return false;
    }
  }

  public handleSelect = (key: any) => {
    // tslint:disable-line
    const { onSelect } = this.props;
    onSelect && onSelect(key);
  };

  public renderCommon() {
    const { role, activeKey, bsStyle, NavContent, colorUnderline = 'primary', justified = false } = this.props;
    const isPills = bsStyle === 'pills';
    const isTabs = bsStyle === 'tabs';

    const classes = classNames('hlc-nav', `hlc-${colorUnderline}`, 'nav', {
      ['menu__list']: isPills,
      ['clearfix']: isPills,
      ['nav-pills']: isPills,
      ['nav-tabs']: isTabs,
      ['nav-justified']: justified,
    });

    return (
      <ul className={classes} role={role}>
        {React.Children.map(this.props.children, (child) => {
          if (React.isValidElement(child)) {
            const active = this.isActive(child as ReactElement<INavItemProps>);
            return cloneElement(child as ReactElement<any>, {
              // tslint:disable-line
              NavContent,
              active,
              activeKey,
              onSelect: this.handleSelect,
            });
          } else {
            return child;
          }
        })}
      </ul>
    );
  }

  public renderPills() {
    return <nav className={'menu menu--prospero clearfix'}>{this.renderCommon()}</nav>;
  }

  public render() {
    const renderMethod = this.props.bsStyle === 'tabs' ? 'renderCommon' : 'renderPills';
    return this[renderMethod]();
  }
}

export default Nav;
